import api from "../api";
import type { PartsTable } from "../models/Partslist";

type ApiResponse<T> = { statusCode: number; message?: string; data?: T };

export async function fetchPartsPrice(oem: string): Promise<PartsTable[]> {
  const { data } = await api.get<ApiResponse<PartsTable[]>>(`/Parts/part-master-missing-data/${oem}`);
  if (data?.statusCode === 200 && Array.isArray(data.data)) return data.data;
  return [];
}


export async function updatePartsPrice(
  oem: string,
  partsToUpdate: PartsTable[]
): Promise<ApiResponse<any>> {
  const sanitized = partsToUpdate.map((p) => ({
    partId: p.partId,
    partNumber: p.partNumber ?? null,
    description: p.description ?? null,
    uom: p.uom ?? null,
    price: p.price ?? null,
  }));

  const { data } = await api.post<ApiResponse<any>>(
    `/Parts/part-master-missing-update/${oem}`,
    sanitized,
    { headers: { "Content-Type": "application/json" } }
  );

  return data; // 👈 now type matches
}